<div class="service-category-group">
  <h2
    [ngClass]="{
      'service-category-heading': true,
      chevron: true,
      expanded: !detailsHidden,
    }"
    (click)="setDetailsVisible()">
    {{ serviceCategoryName }} <a class="accordion-link">View locations</a>
  </h2>
  <div [ngClass]="{ hidden: detailsHidden, expanded: !detailsHidden }" class="service-category-details">
    <hcf-place-detail
      *ngFor="let placeDetail of filteredPlaceDetails"
      [placeDetail]="placeDetail"
      [serviceCategoryName]="serviceCategoryName"
      class="place-detail"></hcf-place-detail>
  </div>
</div>
